import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import AdapterListNews from "./adapter/AdapterListNews";

import store from "../../../../redux/store";
import {serviceActionSuccess} from "./action/ActionListNewsScreen";
import {typeExport} from "../../../../redux/store/type";
import HMButton from "../../../../customviews/HMButton";

let container = null;
export default class ListNewsScreen extends Component {
    constructor(props) {
        super(props);

        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 800 ? 2 : 1;

        }

        this.state = {

            token: "359601088562055",
            checkPushResultOffline: false,


            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
        };
        // this.props.callserviceActionRefresh()
        //    global.link_type=this.props.route.params.item.link_type;

        // global.IdCity=1 ;
        this.getData(1)
    }

    state = {
        show: false
    };

    componentWillReceiveProps(propss) {

    }

    componentWillMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 800 ? 2 : 1,
                    },
                )


            })
        //  this.props.callServiceAddFirst(this.props.route.params.result, this.props.item_count);
    }

    /*    componentDidMount() {
            this.onLoad()
        }

        onLoad = () => {
        }*/
    componentWillUnmount() {
        this.props.callserviceActionRefresh()
        //  this.props.callServiceAddFirst(this.props.route.params.result, this.props.item_count);
    }

    async getData(page) {
        let after = "0000-00-00";
        // let _params = JSON.parse(this.props.route.params);
        let _params = this.props.route.params;
        let _item = JSON.parse(_params.item);
       // _params?.func?.();
        //   this.props.callService(urlListNewsScreen, `?type=${this.props.typee}&city=`, TypeGetListNewsScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListNewsScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListNewsScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListNewsScreen, _GET, page, 10)
  */

        if (store.getState().reducerSplashGetAllData.Connection) {

            // this.props.callService(this.props.route.params.item.link_url, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListNewsScreen, _GET, page, typeExport._Count, this.props.route.params.item.id)
            this.props.callService(_item.link_url.replace(new RegExp('/v1/', "g"), '/v2/'), `&lang=${i18n.locale}&after=${after}&page=${page}&link_type=${_item.link_type}&tenant_id=${store.getState().reducerSplashGetAllData?.City?.tenant_id}`, typeExport.TypeGetListNewsScreen, typeExport._GET, page, typeExport._Count, _item.id)
            // this.props.callService("http://185.113.56.35/wp-json/satia/v2/posts?category=2", `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListNewsScreen, _GET, page, typeExport._Count, _item.id)

        } else {
            let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListNews + `${_item.id}`)
            //this.props.callServiceSuccess(data, 0)
            if (data != null)
                store.dispatch(serviceActionSuccess(data, 0))
            else
                store.dispatch(serviceActionSuccess([], 0))
        }

    }


    render() {
        let _params = this.props.route.params;

        let item = JSON.parse(_params.item)

        return (
            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView
                        style={{width: "100%", height: "100%"}} behavior={"padding"}
                        enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            menu
                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListNews.title')}
                            //text={i18n.t('ListNews.title')}
                            text={(item.name ? item.name : (item.title ? item.title : ''))}

                            back
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        <View style={{flex: 1}}>


                            <FlatList

                                data={this.props.results}
                                renderItem={this.renderItem}
                                keyExtractor={(item, index) => index.toString()}
                                ListEmptyComponent={() => null
                                }
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}

                                numColumns={this.state.columnCount}
                                key={this.state.columnCount}
                            />


                            <EmptyView empty={this.props.empty}/>
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem({item, index}) {
        return <AdapterListNews item={item} index={index}/>;
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {

        if (store.getState().reducerSplashGetAllData.Connection) {
            this.getData(1)
        } else {
            //ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }        //  this.props.callService(urlListNewsScreen, `?type=${this.props.typee}&city=`, TypeGetListNewsScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {
        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashGetAllData.Connection) {
            // this.props.callService(urlListNewsScreen, `?type=${this.props.typee}&city=`, TypeGetListNewsScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }
}
